export default __webpack_public_path__ + "media/components/MapItem/marker-015262ecb216ea2da9d1258c31f37e14.png";